import { ReactElement } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getLanguageFromStorage } from 'helpers'

import { useCreditAccounts } from 'const/syfApiQueries'
import DynamicYieldCard from './DynamicYieldCard'
import getDynamicYieldResponse from './getDynamicYieldResponse'
import { DynamicYieldWrapper } from './subcomponents'
import { DynamicYieldData } from './typings'

const DynamicYieldGrid = (): ReactElement | null => {
  const lang = getLanguageFromStorage()

  const { data, isFetching, isError } = useQuery<DynamicYieldData>(
    ['dynamicYieldData', lang],
    async () => getDynamicYieldResponse()
  )

  const { isError: isCreditError } = useCreditAccounts()

  /*
   * Exclude the legacy `customCardArt` campaign — the Pet on Card entry point
   * is now owned end-to-end by marketing-mfe (offer tile + modal auto-open on
   * deep link). Leaving the DY card here would render a duplicate/stale entry.
   */
  const filteredCampaignsData = data?.campaigns?.filter(
    (campaign) => !!campaign?.title && campaign.id !== 'customCardArt'
  )

  const shouldRenderDY =
    !isFetching &&
    !isError &&
    !isCreditError &&
    Boolean(filteredCampaignsData?.length)

  if (shouldRenderDY) {
    return (
      <DynamicYieldWrapper
        data-cy="dynamic-yield-card"
        data-test="dynamic-yield-card"
      >
        {filteredCampaignsData.map((campaignData) => (
          <DynamicYieldCard
            key={campaignData.title}
            campaignData={campaignData}
          />
        ))}
      </DynamicYieldWrapper>
    )
  }

  return null
}

export default DynamicYieldGrid
